import { render, staticRenderFns } from "./BrandingEdit.vue?vue&type=template&id=20fff83a&scoped=true"
import script from "./BrandingEdit.vue?vue&type=script&lang=js"
export * from "./BrandingEdit.vue?vue&type=script&lang=js"
import style0 from "./BrandingEdit.vue?vue&type=style&index=0&id=20fff83a&prod&lang=scss&scoped=true"
import style1 from "./BrandingEdit.vue?vue&type=style&index=1&id=20fff83a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20fff83a",
  null
  
)

export default component.exports